import { Component } from "react";

export default class Container extends Component {
  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  setState(...args) {
    if (this.mounted) {
      super.setState(...args);
    }
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/containers/Container.jsx